import axios, { getEnv } from '../../../services/api';

export const CidadeService = {
  findByUF: async (uf) => {
    try {
      const response = await axios.get(`${await getEnv('REACT_APP_URL_SERVICE')}/v1/cidades/${uf}`);
      return response.data;
    } catch (error) {
      console.log(error.message);
      throw error;
    }
  },
};
